import { Record } from 'immutable';
const ScreenshotRecord = Record({
  height: undefined,
  bytes: undefined,
  finalUrl: undefined,
  width: undefined
});
export default ScreenshotRecord;